import {isFilled} from '@prismicio/client'
import {PrismicNextImage} from '@prismicio/next/pages'
import type {PricingSectionSliceModulesAndAddonsPrimaryAddOnsItem} from 'prismicio-types'

type AddOnCardProps = {
  addon: PricingSectionSliceModulesAndAddonsPrimaryAddOnsItem
}

export const AddOnCard = ({addon}: AddOnCardProps) => (
  <div className="flex flex-col gap-3 rounded-lg border border-black/[10%] bg-moss-white p-6">
    {/* Icon and Title */}
    <div className="flex items-start gap-4">
      {isFilled.image(addon.icon) && (
        <div className="flex size-8 shrink-0 items-center justify-center rounded-[4px] border border-black/[10%] bg-green-neon">
          <PrismicNextImage field={addon.icon} className="size-4" />
        </div>
      )}
      {isFilled.keyText(addon.add_on_name) && (
        <h3 className="text-tg-body-l font-medium text-moss-black">{addon.add_on_name}</h3>
      )}
    </div>

    {/* Description */}
    {isFilled.keyText(addon.description) && (
      <p className="text-tg-body-m text-grey-550 md:min-h-[100px] lg:min-h-[124px]">{addon.description}</p>
    )}
  </div>
)
